import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchAllLayoutCustomizations, PageType } from "./api"

export function useFetchLayoutCustomizations() {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["layout_customizations"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchAllLayoutCustomizations(context)
    },
  })
}

export function useLayoutCustomization(pageType: PageType) {
  const { data } = useFetchLayoutCustomizations()
  return data?.find((lc) => lc.page_type === pageType) ?? null
}
